// Bỏ dấu tiếng Việt + lowercase để search không phân biệt dấu (vd. "thiên" khớp "Thiện")
export default (str) => {
    return String(str || '')
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/đ/g, 'd')
        .replace(/Đ/g, 'D')
        .toLowerCase()
}
